<div class="flex-column height-100 bg-col-w b-radius-4-s b-radius-4-m">
    <div *ifSize="'XL'"
         class="m-a-8 m-b-2">
        <div class="right">
            <!-- close button -->
            <button role="button"
                    aria-label="Close"
                    (click)="close()">
                <i class="icon-close"
                   aria-hidden="true"></i>
            </button>
        </div>
        <div class="flex flex-middle flex-justify-between m-t-5">
            <p class="h3">{{'Basket' | translate}}</p>
            <p class="p1 col-11">{{(basket.qty === 1 ? '% item' : '% items') | translate : basket.qty}}</p>
        </div>
    </div>
    <div *ifSize="'SM'"
         class="p-a p-b-5 b-b b-col-51">
        <div class="flex flex-justify-between">
            <p class="h3">{{'Basket' | translate}}</p>
            <button role="button"
                    aria-label="Close"
                    (click)="close()">
                <i class="icon-close"
                   aria-hidden="true"></i>
            </button>
        </div>
    </div>

    <!-- content -->
    <div class="overflow-auto custom-scrollbar flex-grow m-t-6 p-l-10 p-r-10 p-l-4-s p-r-4-s p-l-4-m p-r-4-m"
         cy-minibasketView>

        @if (basket.qty) {
        <div>
            <!-- free shippoing label -->
            <basket-free-shipping class="block m-b-8"></basket-free-shipping>
            <!-- basket items -->
            @for (item of basket.items; track item.id; let last = $last; let first = $first) {
            <basket-view-item class="block p-b-6 b-col-4"
                              [class.m-t-6]="!first"
                              [class.b-b]="!last"
                              [item]="item"
                              [context]="'minibasket'"
                              cy-minibasketItem></basket-view-item>
            }
        </div>
        }
        <!-- empty -->
        @if (!basket.qty) {
        <div cy-basketEmpty
             class="center p2 col-1">
            {{'Your basket is empty' | translate}}
        </div>
        }

    </div>

    <!-- bottom part -->
    @if (basket.qty) {
    <div
         class="w-12 p-l-10 p-r-10 p-l-4-s p-r-4-s p-t-3-s p-t-3-m p-l-4-m p-r-4-m b-t-s b-t-m b-col-51 p-t p-b-5 _hideEmpty _shadow">
        <!-- totals -->
        <basket-view-totals [isMinibasket]="true"
                            class="block"></basket-view-totals>
        <!-- promo banner -->
        <become-pro-banner class="block m-t"></become-pro-banner>

        <!-- submission -->
        <basket-view-submit class="block m-t m-t-2-s m-t-2-m"
                            [redirectPath]="'/basket'"></basket-view-submit>

        <!-- delivery info -->
        <div *ifSize="'!SM'"
             class="flex flex-justify-center m-t m-t-2-s m-t-2-m">
            <div class="p-a-2 col-11 b-a b-col-5 b-radius-4 flex flex-middle">
                <i class="icon-small m-r-1"
                   [ngClass]="content?.icon"></i>
                <p class="c1"
                   *iCms="'text' of content; content: 'html'"></p>
            </div>
        </div>
    </div>
    }

</div>